import { productTypes } from '@fr/constants';

export interface SearchFormDictionaryUrls {
    formUrl?: string;
    searchUrl?: string;
    resortsUrl?: string;
}

const RAILWAY_SLUG = 'railways_search';

const RAILWAY_URLS: SearchFormDictionaryUrls = {
    formUrl: `/apiV1/destinationList/serp?slug=${RAILWAY_SLUG}`,
    searchUrl: `/intelligentSearch?slug=${RAILWAY_SLUG}`,
    resortsUrl: `/apiV1/resort/searchByCountry?slug=${RAILWAY_SLUG}`,
};

/**
 * Отельная страница выставляет appConfig под туровый справочник (slug=hotel_page), поэтому в ЖД
 * вертикали форма предлагала направления без ЖД-туров — например Анталью. Возвращаем ЖД-справочники
 * явно; для остальных вертикалей пусто, и либа падает на фолбэк из appConfig.
 */
export default function getSearchFormDictionaryUrls(searchSource?: string): SearchFormDictionaryUrls {
    return searchSource === productTypes.RAILWAY_TOUR ? { ...RAILWAY_URLS } : {};
}
